export default __webpack_public_path__ + "static/media/interface-13.95fd2250.png";